import React from "react";
import CampaignMappingDropdown from "./CampaignMappingDropdown";
import { useSelector } from "react-redux";
import { useGetCampaignMappingConfigQuery, useUpdateCampaignMappingConfigMutation, useGetRegexMapTableQuery } from "../../redux/api/campaignMappings";
import { Table, Form, Input, Button, Popconfirm, message } from "antd";

const RegexPage = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name'] || '');
    const selectedClientRegion = "ALL"
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date'] || '');
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date'] || '');
    const selectedCampaignMappingConfigName = useSelector((state) => state.genericReporting.selectedDropdownValues['campaign_mapping_config_name'] || '');

    const [form] = Form.useForm();

    const columns = [
        {
            title: 'Regex',
            dataIndex: 'regex',
        },
        {
            title: 'Category',
            dataIndex: 'category',
        },
        {
            title: 'Delete',
            key: 'delete',
            render: (_, __, index) => (
                <Popconfirm
                    title="Delete rule?"
                    okText="Delete"
                    cancelText="Cancel"
                    disabled={!isSuccess || isUpdating}
                    onConfirm={() => handleDeleteRegexRule(index)}
                >
                    <Button danger disabled={!isSuccess || isUpdating}>Delete</Button>
                </Popconfirm>
            ),
        },
    ];

    const regexMapTableColumns = [
        {
            title: 'Campaign Name',
            dataIndex: 'campaign_name',
        },
        {
            title: "Matched Regex Rule",
            dataIndex: 'matched_regex',
        },
        {
            title: 'Category',
            dataIndex: 'category',
        },
    ];

    const { data: campaignMappingConfig, isSuccess } = useGetCampaignMappingConfigQuery({ clientName: selectedClient, clientRegion: selectedClientRegion, configName: selectedCampaignMappingConfigName });
    const rules = Array.isArray(campaignMappingConfig?.regex_rules)
        ? campaignMappingConfig.regex_rules
        : (Array.isArray(campaignMappingConfig) ? campaignMappingConfig : []);
    const [updateCampaignMappingConfig, { isLoading: isUpdating }] = useUpdateCampaignMappingConfigMutation();
    const { data: regexMapTable, isSuccess: isRegexMapTableSuccess } = useGetRegexMapTableQuery({ clientName: selectedClient, clientRegion: selectedClientRegion, configName: selectedCampaignMappingConfigName, startDate: selectedStartDate, endDate: selectedEndDate });

    const handleAddRegexRule = async (values) => {
        if (!selectedClient || !selectedCampaignMappingConfigName) {
            message.error('Please select a client and config first.');
            return;
        }

        if (!isSuccess) {
            message.error('Config not loaded yet. Please wait and try again.');
            return;
        }

        const existingSanitizedRules = (Array.isArray(campaignMappingConfig?.regex_rules) ? campaignMappingConfig.regex_rules : (Array.isArray(campaignMappingConfig) ? campaignMappingConfig : [])).map((rule) => ({
            category: rule.category,
            regex: rule.regex
        }));
        const updatedRules = [
            ...existingSanitizedRules,
            { category: values.category, regex: values.regex }
        ];

        const body = {
            client_name: selectedClient,
            client_region: selectedClientRegion,
            config_name: selectedCampaignMappingConfigName,
            regex_rules: updatedRules
        };

        try {
            await updateCampaignMappingConfig({ body }).unwrap();
            message.success('Regex rule added');
            form.resetFields();
        } catch (error) {
            message.error('Failed to add regex rule.');
        }
    };

    const handleDeleteRegexRule = async (index) => {
        if (!selectedClient || !selectedCampaignMappingConfigName) {
            message.error('Please select a client and config first.');
            return;
        }

        if (!isSuccess) {
            message.error('Config not loaded yet. Please wait and try again.');
            return;
        }

        const baseRules = Array.isArray(campaignMappingConfig?.regex_rules)
            ? campaignMappingConfig.regex_rules
            : (Array.isArray(campaignMappingConfig) ? campaignMappingConfig : []);

        const sanitizedRules = baseRules.map((rule) => ({
            category: rule.category,
            regex: rule.regex
        }));

        const updatedRules = sanitizedRules.filter((_, i) => i !== index);

        const body = {
            client_name: selectedClient,
            client_region: selectedClientRegion,
            config_name: selectedCampaignMappingConfigName,
            regex_rules: updatedRules
        };

        try {
            await updateCampaignMappingConfig({ body }).unwrap();
            message.success('Rule deleted');
        } catch (error) {
            message.error('Failed to delete rule.');
        }
    };
        
    return (
        <div>
            <h3>Regex Page</h3>
            <CampaignMappingDropdown />
            <br></br>
            <br></br>
            <div>
                <Form layout="inline" form={form} onFinish={handleAddRegexRule} style={{ marginBottom: 16 }}>
                    <Form.Item name="regex" rules={[{ required: true, message: 'Regex is required' }]}>
                        <Input placeholder="Regex" disabled={!isSuccess || isUpdating} />
                    </Form.Item>
                    <Form.Item name="category" rules={[{ required: true, message: 'Category is required' }]}>
                        <Input placeholder="Category" disabled={!isSuccess || isUpdating} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={isUpdating} disabled={!isSuccess}>Add</Button>
                    </Form.Item>
                </Form>
                <Table rowKey={(record, index) => index} dataSource={rules} columns={columns} />
                <br></br>
                <Table
                    rowKey={(record, index) => index}
                    dataSource={Array.isArray(regexMapTable) ? regexMapTable : []}
                    columns={regexMapTableColumns}
                    loading={!isRegexMapTableSuccess}
                />
            </div>
        </div>
    );
};

export default RegexPage;